/*
 *  Filename........: eventBus.js
 *  Project.........: logistik-app
 *  @copyright......: YBM Deutschland Andy Puderbach und Stephan Wienczny GBR
 *  @version........: 1.0
 *
 *  @since..........: 29.07.20, 08:39
 *  @author.........: Robin Rick
 *
 *  @brief..........:
 */
import Vue from 'vue';
const eventBus = new Vue();

export default eventBus;
